export default __webpack_public_path__ + "static/media/ly.c0460253.svg";